import { OrderLookupPage } from '../../components/pages/orders/lookup'
export default OrderLookupPage
